"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equivalent_entry = void 0;
exports.equivalent_entry = {
    $grammar: {
        "equivalent_entry:via": ['"|"', { via: "exp" }, '"="', { to: "exp" }],
        "equivalent_entry:via_refl": ['"="', { to: "exp" }],
    },
};
//# sourceMappingURL=equivalent_entry.js.map